import Button from '@rio-cloud/rio-uikit/Button';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router';

import type { RfidCardType } from '@/api/schema';
import SupportModal from '@/features/chargingActivity/components/SupportModal';
import { t } from '@/lib/utils';
import { useUserStore } from '@/stores/userStore';

interface ToolbarProps {
    rows?: RfidCardType[];
    activeSelected: boolean | undefined;
    setActiveSelected: (value: boolean | undefined) => void;
}

interface FilterButtonProps {
    isActive: boolean;
    activeSelected: boolean | undefined;
    toggleActiveFilter: (isActive: boolean) => void;
    count?: number;
}

const FilterButton = ({ isActive, activeSelected, toggleActiveFilter, count }: FilterButtonProps) => (
    <Button
        onClick={() => toggleActiveFilter(isActive)}
        className={`btn ${activeSelected === isActive ? 'btn-primary' : 'btn-default'} width-80`}
    >
        <span>
            <FormattedMessage id={isActive ? 'general.active' : 'general.inactive'} />{' '}
            <strong className='text-bold'>{count}</strong>
        </span>
    </Button>
);

export const Toolbar = ({ rows, activeSelected, setActiveSelected }: ToolbarProps) => {
    const { account } = useUserStore();
    const navigate = useNavigate();

    const activeCount = rows?.filter(c => c.isActive).length;
    const inactiveCount = rows?.filter(c => !c.isActive).length;

    const canWriteCards = account?.permissions?.includes('emsp-cards.write');

    if (!rows) {
        return null;
    }

    const toggleActiveFilter = (isActive: boolean) => {
        setActiveSelected(activeSelected === isActive ? undefined : isActive);
    };

    const handleOrderClick = () => {
        navigate('?modal=orderCards&modalSource=charging_cards_page');
    };

    return (
        <div className='flex-1-1-0'>
            <div className='display-flex justify-content-between align-items-end'>
                <div className='display-flex flex-column margin-right-15 margin-top-2'>
                    <label className='control-label'>{t('chargingCards.rfidCardStatus')}</label>
                    <div className='btn-group'>
                        <FilterButton
                            isActive={true}
                            activeSelected={activeSelected}
                            toggleActiveFilter={toggleActiveFilter}
                            count={activeCount}
                        />
                        <FilterButton
                            isActive={false}
                            activeSelected={activeSelected}
                            toggleActiveFilter={toggleActiveFilter}
                            count={inactiveCount}
                        />
                    </div>
                </div>
                <div className='display-flex flex-row gap-10'>
                    <SupportModal />
                    {canWriteCards && (
                        <Button className='btn btn-primary margin-top-1' onClick={handleOrderClick}>
                            <span className='uikit-icon icon-plus' aria-hidden='true' />
                            {t('general.orderChargingCard')}
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};
